import React from 'react';

const PaginationCenter = () => {
    return (
        <div className="pagination-div">
            <ul className="pagination center">
                <li><a className="disable" href="#"><i className="ion-ios-arrow-thin-left"></i></a></li>
                <li><a className="page-number" href="#">1</a></li>
                <li><a className="page-number current" href="#">2</a></li>
                <li>.....</li>
                <li><a className="page-number" href="#">9</a></li>
                <li><a href="#"><i className="ion-ios-arrow-thin-right"></i></a></li>
            </ul>
        </div>
    );
};

export default PaginationCenter;